import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom'
import './index.css';
import {Provider} from "react-redux";
import App from './app/App';
import {store} from "./store";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);


const render = () => {
  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <Provider store={store}>
          <BrowserRouter>
            <App/>
          </BrowserRouter>
        </Provider>
      </React.StrictMode>
    </Provider>
  )
};
render()